import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Technical from "./components/Technical";
import Landing from "./components/Landing";
import Header from "./components/Navbar";
import NonTechnical from "./components/NonTechnical";
import Workshop from "./components/Workshop";
import ProgressBar from "react-scroll-progress-bar";
import Footer from "./components/Footer";
import EventPage from "./components/EventPage";
import ScrollToTop from "./components/ScrollToTop";
import Schedule from "./components/Schedule";
import ReactGA from 'react-ga';

function App() {
  useEffect( () => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  },[]);
  
  return (
    <BrowserRouter>
      <div className="bg-black text-slate-100 overflow-hidden scroll-smooth">
        <ProgressBar bgcolor="white" />
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/workshop" element={<Workshop />} />
          <Route path="/technical" element={<Technical />} />
          <Route path="/nontechnical" element={<NonTechnical />} />
          <Route path="/schedule" element={<Schedule />} />
          <Route path="/:key" element={<EventPage/>} />
        </Routes>
        <Header />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
